var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.377 2C18.9964 2 22.7549 5.75855 22.7549 10.3779C22.7548 11.6618 22.4714 12.8947 21.9131 14.042C21.9064 14.0558 21.8988 14.0695 21.8916 14.083C21.102 15.6587 18.8486 19.4682 16.4639 23.499L15.2959 25.4756C15.1042 25.8003 14.7542 26 14.377 26C13.9998 25.9999 13.6507 25.8002 13.459 25.4756L12.29 23.4971C9.88904 19.4383 7.62133 15.6047 6.84668 14.0498C6.28364 12.8951 6.00006 11.6625 6 10.3779C6 5.75868 9.75772 2.00022 14.377 2ZM14.377 5.98438C12.1175 5.98454 10.2794 7.82253 10.2793 10.082C10.2793 12.3416 12.1174 14.1805 14.377 14.1807C16.6367 14.1807 18.4756 12.3417 18.4756 10.082C18.4755 7.82243 16.6366 5.98438 14.377 5.98438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.328db5cdb5a7f688fece7cebe0cd289c.svg";
export { ForwardRef as ReactComponent };